import { TFunction } from "i18next";
import { ColumnDef } from "~/components/table";

import { Checkbox } from "~/components/ui/checkbox";
import { DataTableColumnHeader } from "~/components/ui/data-table-column-header";
import { ITrendWithProducts } from "~/contexts/trends-context";
import { Text } from "~/components/text";

export const getColumns = (t: TFunction): ColumnDef<ITrendWithProducts>[] => [
  {
    id: "select",
    size: 0,
    header: ({ table }) => (
      <div>
        <Checkbox
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && "indeterminate")
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
          className="translate-y-[2px]"
        />
      </div>
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
        className="translate-y-[2px]"
      />
    ),
  },
  {
    accessorKey: "term",
    size: NaN,
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={t("searchTerms:table.headers.name")}
      />
    ),
    cell: ({ row }) => (
      <Text as="div" variant="body">
        {row.getValue("term")}
      </Text>
    ),
  },
  {
    accessorKey: "productsCount",
    size: NaN,
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={t("searchTerms:table.headers.books")}
      />
    ),
    cell: ({ row }) => (
      <span className="truncate">
        {`${row.getValue("productsCount")} Books`}
      </span>
    ),
  },
];
